import { ProductionFormula } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import type { ItemResponse } from './inventory';
import { DataFetcherFunction } from '../compiler/types';

export interface ProductionFormulaResponse {
    uuid: string
    owner_uuid: string
    name: string
    description: string
    input_service_lines: Array<{
        service_uuid: string
        quantity: number
        ordering: number
    }>
    input_product_lines: Array<{
        product_uuid: string
        quantity: number
        ordering: number
        product: ItemResponse | null
    }>
    output_product_lines: Array<{
        product_uuid: string
        quantity: number
        ordering: number
        product: ItemResponse | null
    }>
    quantity_producible?: number
    created_at: string
    updated_at: string
}

export interface CreateProductionFormulaRequest {
    name: string
    description: string
    inputServiceLines: Array<{
        service_uuid: string
        quantity: number
    }>
    inputProductLines: Array<{
        product_uuid: string
        quantity: number
    }>
    outputProductLines: Array<{
        product_uuid: string
        quantity: number
    }>
}

export default (axios: AxiosInstance = baseAxios): { createProductionFormula: (data: CreateProductionFormulaRequest) => Promise<ProductionFormula>; fetchProductionFormula: (uuid: string) => Promise<ProductionFormula>; fetchProductionFormulas: (preRequest?: (uri: URL) => URL) => DataFetcherFunction<ProductionFormula>; deleteProductionFormula: (uuid: string) => Promise<void>; } => ({
    createProductionFormula: async (data: CreateProductionFormulaRequest): Promise<ProductionFormula> => {
        const response = await axios.post<{ data: ProductionFormula }>('/api/inventory/production-formulas', data);
        return response.data.data;
    },

    fetchProductionFormula: async (uuid: string): Promise<ProductionFormula> => {
        const response = await axios.get<{ data: ProductionFormula }>(`/api/inventory/production-formulas/${uuid}`);
        return response.data.data;
    },

    fetchProductionFormulas: (preRequest?: (uri: URL) => URL): DataFetcherFunction<ProductionFormula> =>
        fetchPaginatedDataFunction<ProductionFormula>('/api/inventory/production-formulas', preRequest, axios),

    deleteProductionFormula: async (uuid: string): Promise<void> => {
        await axios.delete(`/api/inventory/production-formulas/${uuid}`);
    },
});
